import React from 'react';
import styles from './MiniPagination.module.scss';
import cx from 'classnames';
import ChevronLeftS1 from 'plaid-threads/Icons/ChevronLeftS1';
import ChevronRightS1 from 'plaid-threads/Icons/ChevronRightS1';

interface MiniPaginationProps {
  totalItems: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  className?: Parameters<typeof cx>[0];
  isActive: boolean;
}

const MiniPagination: React.FC<MiniPaginationProps> = ({
  totalItems,
  currentPage,
  onPageChange,
  className,
  isActive,
}) => {
  const pages = Array.from({ length: totalItems }, (_, i) => i);

  return (
    <div
      className={cx(
        styles.paginationWrapper,
        className,
        !isActive && styles.faded,
      )}
    >
      <button
        className={styles.arrow}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 0 || !isActive}
        data-testid='arrow-left'
      >
        <ChevronLeftS1 />
      </button>
      {pages.map((page) => (
        <div
          key={page}
          className={cx(styles.dot, {
            [styles.selected]: currentPage === page,
            [styles.active]: isActive,
          })}
          onClick={() => isActive && onPageChange(page)}
          data-testid={`dot-${page}`}
        ></div>
      ))}
      <button
        className={styles.arrow}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalItems - 1 || !isActive}
        data-testid='arrow-right'
      >
        <ChevronRightS1 />
      </button>
    </div>
  );
};

export default MiniPagination;
